import type { Facet } from './interfaces';
import type { FilterElement } from '@spa/lib/tracking/interactiveTrackingEventSchema';

/**
 * Derives the `filter_element` for a facet-value / accordion interaction from the facet
 * shape (ECOM-5703 AC2). The `suche` (brand search input) and `link` (category navigation)
 * elements are not facet-shape-derived — their sites pass those literals explicitly.
 */
export const deriveFilterElement = (facet: Facet): FilterElement => {
  switch (facet.type) {
    case 'range':
      return 'slider';
    case 'boolean':
      return 'toggle';
    default:
      return 'checkbox';
  }
};

/** `filter_value` for a slider facet: the selected range as `"{from}-{to}"` (AC4). */
export const formatSliderValue = (from: number, to: number): string => `${from}-${to}`;

/** `filter_value` for a boolean/toggle facet: the raw `"true"`/`"false"` value as a boolean (AC4). */
export const parseToggleValue = (rawValue: string): boolean => rawValue === 'true';
